export { fetchPermissionResources } from './api';

export type {
  PermissionAction,
  PermissionApiResponse,
  PermissionResourceData,
} from './api';
